$w.onReady(() => {
waitForLoading();
});
export function button6_onClick() {
$w('#image').show();
waitForLoading();
}
function waitForLoading() {
setTimeout(() => {
$w('#image').hide('FadeOut');
}, 15000);
}
